// @flow
import withToggle from './withToggle';

export default withToggle('isOpen', 'toggleModal');

export type WithModalProps = {
  isOpen: boolean,
  toggleModal: (e: SyntheticEvent<HTMLElement>) => void,
};
